<template>
  <div id="classification">
    <div class="top">
      <div class="title">详细信息\ {{ contractId }}</div>
    </div>
    <div class="bottom_main">
      <div class="main-top">
        <div class="progress_item">
          <div class="progress_item_top">
            <div
              :class="progressState[0] == 0 ? 'active_item_icon' : 'item_icon'"
            >
              <div v-if="progressState[0] == 2 || progressState[0] == 0">1</div>
              <i v-if="progressState[0] == 1" class="el-icon-check"> </i>
            </div>
            <div class="item_title">下达至设计</div>
            <div class="item_line"></div>
          </div>
          <div class="progress_item_bottom">
            <div>计划员：{{ designDetail[0].field0009 }}</div>
            <div>接收人：{{ designDetail[0].field0010 }}</div>
            <div>设计室：{{ designDetail[0].field0028 }}</div>
            <div>回复交期：{{ designDetail[0].field0019 }}</div>
            <div>
              下达日期：{{
                designDetail[0].field0011
                  ? convertDateFormat(designDetail[0].field0011)
                  : ''
              }}
            </div>
          </div>
        </div>
        <div class="progress_item">
          <div class="progress_item_top">
            <div
              :class="progressState[1] == 0 ? 'active_item_icon' : 'item_icon'"
            >
              <div v-if="progressState[1] == 2 || progressState[1] == 0">2</div>
              <i v-if="progressState[1] == 1" class="el-icon-check"> </i>
            </div>
            <div class="item_title">设计任务分配</div>
            <div class="item_line"></div>
          </div>
          <div class="progress_item_bottom">
            <div>下达人员：{{ designDetail[1].field0009 }}</div>
            <div>
              下达日期：{{
                designDetail[1].field0011
                  ? convertDateFormat(designDetail[1].field0011)
                  : ''
              }}
            </div>
            <div>主管设计：{{ designDetail[1].field0010 }}</div>
          </div>
        </div>
        <div class="progress_item">
          <div class="progress_item_top">
            <div :class="threeProgress == 0 ? 'active_item_icon' : 'item_icon'">
              <div v-if="threeProgress == 2 || threeProgress == 0">3</div>
              <i v-if="threeProgress == 1" class="el-icon-check"> </i>
            </div>
            <div class="item_title">BOM清单</div>
            <div class="item_line"></div>
          </div>
          <div class="progress_item_bottom">
            <div>BOM人员：{{ BOMMembers }}</div>
            <div>BOM总进度：{{ Number(BOMProgress).toFixed(1) }}%</div>
          </div>
        </div>
        <div class="progress_item">
          <div class="progress_item_top">
            <div
              :class="progressState[2] == 0 ? 'active_item_icon' : 'item_icon'"
            >
              <div v-if="progressState[2] == 2 || progressState[2] == 0">4</div>
              <i v-if="progressState[2] == 1" class="el-icon-check"> </i>
            </div>
            <div class="item_title">设计资料</div>
            <div class="item_line"></div>
          </div>
          <div class="progress_item_bottom"></div>
        </div>
        <div class="progress_item">
          <div class="progress_item_top">
            <div
              :class="progressState[3] == 0 ? 'active_item_icon' : 'item_icon'"
            >
              <div v-if="progressState[3] == 2 || progressState[3] == 0">5</div>
              <i v-if="progressState[3] == 1" class="el-icon-check"> </i>
            </div>
            <div class="item_title">检验技术要求</div>
            <div class="item_line"></div>
          </div>
          <div class="progress_item_bottom">
            <div>设计组长：{{ designDetail[3].field0020 }}</div>
            <div>检验人员：{{ designDetail[3].field0014 }}</div>
            <div>检验日期：{{ designDetail[3].field0006 }}</div>
            <div>操作人员：{{ designDetail[3].field0019 }}</div>
          </div>
        </div>
      </div>
      <div class="main-bottom">
        <div class="bottom-left">
          <div class="bottom-left-top">
            <Allocation :contractId="contractId" ref="Allocation" />
          </div>
          <div class="bottom-left-bottom">
            <BOMProgress ref="BOMProgress" />
          </div>
        </div>
        <div class="bottom-right">
          <DetailProgress
            @setCurrentProgress="setCurrentProgress"
            ref="DetailProgress"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiMain, apiMainMultiple } from '@/api/mainapi.js';
import { convertDateFormat } from '@/utils/tools.js';
import Allocation from './allocation.vue';
import BOMProgress from './BOMProgress.vue';
import DetailProgress from './detailProgress.vue';
import { set } from 'vue';
export default {
  name: 'classification',
  components: { Allocation, BOMProgress, DetailProgress },
  data() {
    return {
      progressState: [2, 2, 2, 2], //2 未开始 0进行中 1已完成
      threeProgress: 2,
      isFour: false,
      aheadProgress: 0, //前两个进度
      firstProgress: 0, //步骤一状态
      secondProgress: 0, //步骤二状态
      currentProgress: 3, //当前进度
      BOMMembers: '', //BOM人员
      BOMProgress: 0, //BOM总进度
      allocationID: '',
      currentERPBOMPage: 1, //当前页
      ERPBOMTotal: 0, //总数据数
      ERPBOMPageSize: 5, //
      ERPBOMListColumn: [
        {
          prop: 'FName',
          label: '名称'
        },
        {
          prop: 'FModel',
          label: '型号'
        },

        {
          prop: 'stockQty',
          label: '库存'
        },
        {
          prop: 'FQty',
          label: '数量'
        },
        {
          prop: 'wayQty',
          label: '在途数量'
        },
        {
          prop: 'Unit',
          label: '单位'
        },
        {
          prop: 'stock',
          label: '库房'
        },
        {
          prop: 'FShortNumber',
          label: '代码'
        }
      ],
      ERPBOMList: [],
      designDetail: [
        {
          field0009: '',
          field0010: '',
          field0011: '',
          field0019: '',
          field0028: ''
        },
        {
          field0009: '',
          field0010: '',
          field0011: ''
        },
        {
          finishedflag: ''
        },
        {
          field0020: '',
          field0014: '',
          field0006: '',
          field0019: ''
        }
      ],
      hasDesignDetail: false
    };
  },
  computed: {
    contractId() {
      if (window.location.href.indexOf('id') > 0) {
        let url = window.location.href;
        let id = decodeURIComponent(url).split('?id=')[1];
        return id;
      } else if (window.sessionStorage.getItem('currentContractId')) {
        return window.sessionStorage.getItem('currentContractId');
      }
    }
  },
  mounted() {
    let contractId;
    if (window.location.href.indexOf('id') > 0) {
      let url = window.location.href;
      contractId = decodeURIComponent(url).split('?id=')[1];
      window.sessionStorage.setItem('currentContractId', contractId);
    } else if (window.sessionStorage.getItem('currentContractId')) {
      contractId = window.sessionStorage.getItem('currentContractId');
    }
    this.getDesignDetail(contractId);
    this.getBOMProgress(contractId);
    this.$refs.BOMProgress.getTableData(contractId);
    this.$refs.DetailProgress.getTableData(contractId);
  },
  methods: {
    //获取设计进度
    async getDesignDetail(contractId) {
      const params = {
        Type: 'DesignDetail',
        contractNo: contractId
      };
      const res = await apiMain(params);
      this.designDetail = res.data.data;
      this.currentProgress = res.data.data.length;
      res.data.data.forEach((item, index) => {
        if (item.finishedflag == 0 || item.finishedflag == 1) {
          this.progressState[index] = item.finishedflag;
        } else {
          this.progressState[index] = 2;
        }
      });
      console.log('步骤条', this.progressState);
      // if (this.currentProgress == 1) {
      //   this.aheadProgress = 1;
      //   if (res.data.data[0].finishedflag == 1) {
      //     this.firstProgress = 1;
      //   } else {
      //     this.firstProgress = 0;
      //   }
      // } else if (this.currentProgress == 2) {
      //   this.aheadProgress = 2;
      //   if (res.data.data[0].finishedflag) {
      //     this.firstProgress = 1;
      //   } else {
      //     this.firstProgress = 0;
      //   }
      //   if (res.data.data[1].finishedflag) {
      //     this.firstProgress = 1;
      //     this.secondProgress = 1;
      //   } else {
      //     this.secondProgress = 0;
      //   }
      // } else if (this.currentProgress == 4) {

      //   if (res.data.data[0].finishedflag) {
      //     this.firstProgress = 1;
      //   }else{
      //     this.firstProgress = 0;
      //   }
      //   if(res.data.data[1].finishedflag){
      //     this.secondProgress = 1;
      //   } else {
      //     this.secondProgress = 0;
      //   }
      // } else {
      //   this.aheadProgress = 0;
      // }
      // debugger;
      if (res.data.data.length > 1) {
        this.allocationID = res.data.data[1].id;
        this.hasDesignDetail = true;
      } else {
        this.hasDesignDetail = false;
      }
      this.$refs.Allocation.getTableData(this.allocationID);
    },
    // 获取bom信息
    async getBOMProgress(contractId) {
      const params = {
        Type: 'BOMProgress',
        contractNo: contractId
      };
      const res = await apiMain(params);
      // debugger;
      let index = res.data.data.length - 1;
      if (res.data.data.length && this.hasDesignDetail) {
        this.threeProgress = 0;
        if (res.data.data[index].BOM进度 == 100) {
          this.threeProgress = 1;
        } else if (res.data.data[index].BOM进度 == 0) {
          this.threeProgress = 2;
        }
        let member = [];
        res.data.data.forEach((item) => {
          if (item.member) {
            member.push(item.member);
          }
        });

        let newArr = [...new Set(member)]; //人员名称去重
        this.BOMMembers = newArr.join('、');
        this.BOMProgress = res.data.data[index].BOM进度;
      }
    },
    convertDateFormat(data) {
      return convertDateFormat(data);
    },
    setCurrentProgress(data) {
      this.isFour = data;
    }
  }
};
</script>

<style scoped lang="scss">
#classification {
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;

  .left {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    padding-left: 40px;
  }
  .right {
    width: 43%;
    height: 100%;
  }
}
.top {
  // height: 7%;
  height: 70px;
  width: 100%;
  // background-color: rgb(145, 113, 71);
  .title {
    position: relative;
    // left: 5%;
    left: 80px;
    // width: 20%;
    width: 450px;
    height: 97%;
    font-size: 1.5rem;
    color: rgba(37, 100, 207, 0.8);
    border-bottom: 0.07rem solid rgba(105, 105, 105, 0.5);
    display: flex;
    align-items: center;
  }
}
.bottom_main {
  padding-left: 20px;
  height: 90%;
  .main-top {
    position: relative;
    background: rgb(255, 255, 255);
    box-sizing: border-box;
    margin-bottom: 20px;
    margin-right: 20px;
    padding: 20px;
    box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    display: flex;
    flex-direction: row;
    height: 220px;
    .progress_item {
      width: 20%;
      height: 100%;
    }
    .progress_item_top {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      .active_item_icon {
        font-size: 21px;
        font-weight: 600;
        background: #1890ff;
        color: #ffffff;
        width: 32px;
        height: 32px;
        border-radius: 50%;
        border: 1px solid #1890ff;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .item_icon {
        font-size: 21px;
        font-weight: 600;
        color: #d9d9d9;
        width: 32px;
        height: 32px;
        border-radius: 50%;
        border: 1px solid #d9d9d9;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .el-icon-check {
        color: #1890ff;
      }
      .item_title {
        width: 100px;
        font-weight: 600;
      }
      .item_line {
        height: 1px;
        background: #d9d9d9;
        width: calc(100% - 132px);
      }
    }
    .progress_item_bottom {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      padding-left: 45px;
      color: #8c8c8c;
      font-weight: 600;
      font-size: 14px;
      height: 70%;
      justify-content: space-evenly;
    }
  }
  .main-bottom {
    height: calc(100% - 220px);
    width: 100%;
    display: flex;
    justify-content: space-between;
    .bottom-left {
      width: 49%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      .bottom-left-top {
        height: 50%;
      }
      .bottom-left-bottom {
        height: 50%;
      }
    }
    .bottom-right {
      width: 49%;
      height: 100%;
    }
  }
}
.right {
  .top {
    // height: 7%;
    height: 70px;
    width: 100%;
    // background-color: rgb(145, 113, 71);
    .title {
      position: relative;
      // left: 5%;
      left: 80px;
      // width: 20%;
      width: 280px;
      height: 97%;
      font-size: 1.5rem;
      color: rgba(37, 100, 207, 0.8);
      border-bottom: 0.07rem solid rgba(105, 105, 105, 0.5);
      display: flex;
      align-items: center;
    }
  }
}
.card-box {
  height: 90%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 24px;
  .left_1 {
    position: relative;
    width: 95%;
    height: 85vh;
    background: rgb(255, 255, 255);
    box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
    border-radius: 2px;
    margin-bottom: 36px;
  }
  .right_1 {
    position: relative;
    width: 100%;
    height: 38vh;
    background: rgb(255, 255, 255);
    box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
    border-radius: 2px;
    margin-bottom: 33px;
  }
  .right_2 {
    position: relative;
    width: 100%;
    height: 38vh;
    background: rgb(255, 255, 255);
    box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
    border-radius: 2px;
    margin-bottom: 33px;
  }
}
.card-top {
  display: flex;
  align-items: center;
}
.card-title {
  position: relative;
  color: rgb(128, 128, 128);
  font-family: Microsoft YaHei;
  font-size: 20px;
  font-weight: 700;
  line-height: 22px;
  letter-spacing: -1px;
  text-align: left;
  margin: 20px;
  width: 60%;
}
.card-tool {
  position: relative;
  color: rgba(37, 100, 207, 0.8);
  font-family: Microsoft YaHei;
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: -1px;
  text-align: left;
  text-decoration-line: underline;
  cursor: pointer;
}
.card_info {
  position: relative;
  height: 65%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: row;
  -webkit-box-align: start;
  -ms-flex-align: start;
  -ms-flex-pack: distribute;
  justify-content: flex-start;
  flex-wrap: wrap;
  align-content: space-around;
  padding-left: 20px;
}
.card_info_lable {
  width: 45%;
  color: #616161;
  font-family: 'Microsoft YaHei';
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0px;
  text-align: left;
  span {
    color: #888888;
  }
}
.main-card {
  display: flex;
  height: 100%;
  width: 100%;
  top: 20px;
  position: relative;
}
.progress {
  display: flex;
  justify-content: space-around;
  width: 90%;
  align-items: center;
}
.card-table {
  padding: 0 20px 0 20px;
}
.table-bottom {
  position: absolute;
  bottom: 20px;
  left: 20%;
}
</style>
